import classNames from 'classnames'
import { ToastContentProps } from 'react-toastify'

import { Icon } from '@/Atomic/Atoms/Icon'

interface PhoneCallLogToastProps extends Partial<ToastContentProps> {
  variant: 'info' | 'success'
  headline: string
  text?: string
  actionLabel?: string
  onAction?: () => void
  secondaryActionLabel?: string
  onSecondaryAction?: () => void
}

export const PhoneCallLogToast: React.FC<PhoneCallLogToastProps> = ({
  variant,
  headline,
  text,
  actionLabel,
  onAction,
  secondaryActionLabel,
  onSecondaryAction,
  closeToast,
}) => {
  const icon =
    variant === 'success' ? 'check-circle-solid' : 'info-circle-solid'

  return (
    <div
      className={classNames(
        'toast show phone-call-toast',
        `phone-call-toast--${variant}`,
      )}
    >
      <div className="toast-body">
        <button className="btn-close" onClick={() => closeToast?.()}></button>
        <div className="phone-call-toast-message">
          <div className="phone-call-toast-icon">
            <Icon icon={icon} size="lg" />
          </div>
          <div className="phone-call-toast-content">
            <h5>{headline}</h5>
            {text && <p className="mb-0">{text}</p>}
            {actionLabel && onAction && (
              <button
                type="button"
                className="phone-call-toast-link"
                onClick={() => {
                  onAction()
                  closeToast?.()
                }}
              >
                {actionLabel}
              </button>
            )}
            {secondaryActionLabel && onSecondaryAction && (
              <button
                type="button"
                className="phone-call-toast-link"
                onClick={() => {
                  onSecondaryAction()
                  closeToast?.()
                }}
              >
                {secondaryActionLabel}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
